module.exports = "<input type=\"text\" id=\"range\" value=\"\" name=\"range\" #range (input)=\"filter('price', range.value)\" />"